import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link, useNavigate } from "react-router-dom";
import {API_URL} from "../utils/api";
import axios  from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { Routes, Route, useParams } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const EditServiceLayer = () => {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);

  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [thumbnail, setThumbnail] = useState("");

  const [titleErr, setTitleErr] = useState(false);
  const [categoryErr, setCategoryErr] = useState(false);
  const [descriptionErr, setDescriptionErr] = useState(false);
  const [thumbnailErr, setThumbnailErr] = useState(false);

    const [isOnlyPricelist, setisOnlyPricelist] = useState(0);
    

  let { id } = useParams();

console.log(id);
   const handleFileChange = async(e) => {
    if (e.target.files && e.target.files.length > 0) {
      var targetFile = e.target.files[0];
      const src = URL.createObjectURL(targetFile);
      setThumbnail(targetFile);
      setImagePreview(src);
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
  };
  const quillRef = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [isHighlightReady, setIsHighlightReady] = useState(false);



async function fetchServiceInfo(){

  axios.get(process.env.REACT_APP_API_BASE_URL+"service-details/"+id)
      .then((res) => {
          // return false;
        if(res.data){
          console.log('red data',res.data);
      let baseurl = API_URL.replace("api", "");
            setTitle(res.data.title);
             setCategory(res.data.category);
             setDescription(res.data.content);
             setThumbnail(res.data.image);
             setImagePreview(baseurl+res.data.image);
             setisOnlyPricelist(res.data.is_only_pricelist);
        }
        else{
          toast.success("something went wrong...")
        }
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });
}
  useEffect(() => {
    // Load highlight.js configuration and signal when ready
    hljs?.configure({
      languages: [
        "javascript",
        "ruby",
        "python",
        "java",
        "csharp",
        "cpp",
        "go",
        "php",
        "swift",
      ],
    });
    fetchServiceInfo();
  }, []);

  // eslint-disable-next-line no-unused-vars
  const handleSave = () => {
    const editorContent = quillRef.current.getEditor().root.innerHTML;
    console.log("Editor content:", editorContent);
  };

  const handleSubmit = () => {

    if(title != "" && category != "" && description != '' && thumbnail!= ''){

    var formData = {
      title : title,
      category : category,
      content : description,
     // thumbnail : thumbnail,
      image:thumbnail,
      is_only_pricelist:isOnlyPricelist?1:0
    };
    console.log(formData);
    axios.post(process.env.REACT_APP_API_BASE_URL+"service-update/"+id, { ...formData }, {
      headers: {
        "content-type": "multipart/form-data"
      },
      
    })
      .then((res) => {
          console.log(res.data);
          // return false;
        if(res.data.status==true){
            toast.success('Record saved sucessfully!!');
            setTimeout(() => {
              navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/service');
            }, 2000);
        }
        else{
          alert("something went wrong...")
        }
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });
    } else{

      if(title == ""){
        setTitleErr(true);
      }
       if(category == ""){
        setCategoryErr(true);
      }
       if(description == ''){
        setDescriptionErr(true);
      }
       if(thumbnail== ''){
        setThumbnailErr(true);
      }
    }
  }

  // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
  const modules = isHighlightReady
    ? {
        syntax: {
          highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
        },
        toolbar: {
          container: "#toolbar-container", // Custom toolbar container
        },
      }
    : {
        toolbar: {
          container: "#toolbar-container", // Custom toolbar container
        },
      };

  const formats = [
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "header",
    "blockquote",
    "code-block",
    "list",
    "indent",
    "direction",
    "align",
    "link",
    "image",
    "video",
    "formula",
  ];

  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Edit New Post</h6>
          </div>
          <ToastContainer></ToastContainer>
          <div className='card-body p-24'>
            
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='title'
                >
                  Post Title:{" "}
                </label>
                <input
                  onChange={(e) =>{
                    setTitle(e.target.value)
                    setTitleErr(false);
                    if(e.target.value == ""){
                     setTitleErr(true);
                    }
                 }
                 }
                 type='text'
                 className={titleErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                   id='title'
                  value={title}
                  placeholder='Enter Post Title'
                />
               {titleErr && (
                        <span className="error-message">
                            {'Title is mandatory'}
                        </span>
                    )}  
              </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Post Category:{" "}
                </label>
                <select value={category} onChange={(e) =>{
                   setCategory(e.target.value)
                   setCategoryErr(false);
                   if(e.target.value == ""){
                    setCategoryErr(true);
                   }
                   }} 
                     className={categoryErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
          >
           <option value=''>Select Category</option>
           <option value='Technology' {...(category == 'Technology')??'selected=true'}>Technology</option>
                  <option value='Business' {...(category == 'Business')??'selected=true'}>Business</option>
                  <option value='Course' {...(category == 'Course')??'selected=true'}>Course</option>
                  <option value='Fashion' {...(category == 'Fashion')??'selected=true'}>Fashion</option>
                </select>
                {categoryErr && (
                        <span className="error-message">
                            {'Category is mandatory'}
                        </span>
                    )}  
              </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Post Description
                </label>
                <div className='border border-neutral-200 radius-8 overflow-hidden'>
                  <div className='height-200'>
                    {/* Toolbar */}
                    <div id='toolbar-container'>
                      <span className='ql-formats'>
                        <select className='ql-font'></select>
                        <select className='ql-size'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-bold'></button>
                        <button className='ql-italic'></button>
                        <button className='ql-underline'></button>
                        <button className='ql-strike'></button>
                      </span>
                      <span className='ql-formats'>
                        <select className='ql-color'></select>
                        <select className='ql-background'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-script' value='sub'></button>
                        <button className='ql-script' value='super'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-header' value='1'></button>
                        <button className='ql-header' value='2'></button>
                        <button className='ql-blockquote'></button>
                        <button className='ql-code-block'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-list' value='ordered'></button>
                        <button className='ql-list' value='bullet'></button>
                        <button className='ql-indent' value='-1'></button>
                        <button className='ql-indent' value='+1'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-direction' value='rtl'></button>
                        <select className='ql-align'></select>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-link'></button>
                        <button className='ql-image'></button>
                        <button className='ql-video'></button>
                        <button className='ql-formula'></button>
                      </span>
                      <span className='ql-formats'>
                        <button className='ql-clean'></button>
                      </span>
                    </div>

                    {/* Editor */}
                    <ReactQuill
                      ref={quillRef}
                      theme='snow'
                      value={description}
                      onChange={(e) =>{
                        console.log('descriptipn:', e);
                        setDescription(e)
                        setDescriptionErr(false);
                        if(e == "" || e == "<p><br></p>"  || e == "<p</p>"){
                          setDescriptionErr(true);
                        }
                        }} 
                      modules={modules}
                      formats={formats}
                      placeholder='Compose an epic...'
                    />
                   {descriptionErr && (
                        <span className="error-message">
                            {'Description is mandatory'}
                        </span>
                    )}    
                  </div>
                </div>
              </div>
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Upload Thumbnail
                </label>
                <div className='upload-image-wrapper'>
                  {imagePreview ? (
                    <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                      <button
                        type='button'
                        className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                        onClick={handleRemoveImage}
                      >
                        <iconify-icon
                          icon='radix-icons:cross-2'
                          className='text-2xl text-white'
                        ></iconify-icon>
                      </button>
                      <img
                        id='uploaded-img__preview'
                        className='w-100 h-100 object-fit-cover'
                        src={imagePreview}
                        alt='Uploaded'
                      />
                    </div>
                  ) : (
                    <label
                      className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                      htmlFor='upload-file'
                    >
                      <iconify-icon
                        icon='solar:camera-outline'
                        className='text-xl text-secondary-light'
                      ></iconify-icon>
                      <span className='fw-semibold text-secondary-light'>
                        Upload
                      </span>
                      <input
                        id='upload-file'
                        type='file'
                        hidden
                        onChange={handleFileChange}
                      />
                    </label>
                  )}
 {thumbnailErr && (
                        <span className="error-message">
                            {'Attachment is mandatory'}
                        </span>
                    )}

                </div>
              </div>
              
               <div>
                               
                            
                                <FormGroup>
                     <FormControlLabel      id='is_only_pricelist'
                                 name='is_only_pricelist'

                                 control={<Checkbox checked={isOnlyPricelist} />} label=" Is Show only in Prices List" 
                      onChange={(e) =>{
              
                        setisOnlyPricelist(!isOnlyPricelist)
                        
                     }
                     }
                     />
                      </FormGroup>
                            </div>
              
              <br />
              <button onClick={() => handleSubmit()} className='btn btn-primary-600 radius-8'>
                Submit
              </button>
            
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default EditServiceLayer;
